import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function AddBudgetCategory() {

    const [category, setCategory] = useState("");
    const [type, setType] = useState("");

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function submitHandler(e) {
        e.preventDefault();

        try {
            const budgetCatRef = firestore.collection("budget-categories");

            const data = {
                category: category,
                type: type
            }
            budgetCatRef.add(data);
            setMessage("Kategori lagt til");
        } catch (error) {
            setError("Kunne ikke legge til");
        }

    }

    return (
        <form onSubmit={submitHandler}>
            <label>Navn på kategori</label>
            <input className="form-control mb-2" value={category} onChange={e => setCategory(e.target.value)} placeholder="Kategori" />

            <label>Velg type (inntekt eller utgift)</label>
            <select className="browser-default custom-select" onChange={e => setType(e.target.value)}>
                <option>Velg type</option>
                <option value="income">Inntekt</option>
                <option value="expense">Utgift</option>
            </select>

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}

            <button className="btn btn-success btn-block">Lagre kategori</button>

        </form>
    )
}
export default AddBudgetCategory